import { Isintomas } from './Main';

import sint1 from '../../assets/images/sint1.jpg';
import sint2 from '../../assets/images/sint2.jpg';
import sint3 from '../../assets/images/sint3.jpg';
import sint4 from '../../assets/images/sint4.jpg';
import sint5 from '../../assets/images/sint5.jpg';
import sint6 from '../../assets/images/sint6.jpg';

export const sintomas: Isintomas[] = [
  {
    image: <img src={sint1} alt="test" />,
    title: 'Telangiectasias',
    selected: false,
    id: 1,
  },
  {
    image: <img src={sint2} alt="test" />,
    title: 'Veias varicosas',
    selected: false,
    id: 2,
  },
  {
    image: <img src={sint3} alt="test" />,
    title: 'Edema venoso',
    selected: false,
    id: 3,
  },
  {
    image: <img src={sint4} alt="test" />,
    title: 'Alterações tróficas da pele das pernas ou pés',
    selected: false,
    id: 4,
  },
  {
    image: <img src={sint5} alt="test" />,
    title: 'Úlcera cicatrizada',
    selected: false,
    id: 5,
  },
  {
    image: <img src={sint6} alt="test" />,
    title: 'Úlcera ativa',
    selected: false,
    id: 6,
  },
];

export const sintomasResp: Isintomas[] = [
  {
    image: <img src={sint1} alt="test" />,
    title: 'Telangiectasias',
    selected: false,
    id: 1,
  },
  {
    image: <img src={sint2} alt="test" />,
    title: 'Veias varicosas',
    selected: false,
    id: 2,
  },
  {
    image: <img src={sint3} alt="test" />,
    title: 'Edema venoso',
    selected: false,
    id: 3,
  },
  {
    image: <img src={sint4} alt="test" />,
    title: 'Alterações tróficas da pele das pernas ou pés',
    selected: false,
    id: 4,
  },
  {
    image: <img src={sint6} alt="test" />,
    title: 'Úlcera cicatrizada e ativa',
    selected: false,
    id: 5,
  },
];
